import React, { FC, memo, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AnyStyledComponent } from 'styled-components'

import { Container, Text, Label, Icon, Input } from './checkbox-radio-filter-styles'
import { encodeToBase64 } from '../../../../../utils/encoding-utils'
import { FilterItemTransport } from '../../../../../transports/filters-configuration-transport'
import { FilterType } from '../../types'
import { filterGATracking, preventEvent } from '../../utils'
import { filterClick, getFilterError, getRegionNodeId } from '../../../../../redux/filters'

import { Dispatch } from '../../../../../redux/types'
import { useRequestUserConfigContext } from '../../../../../hooks/request'

import CheckboxCheckedIcon from '../../../../../assets/icons/black-checkbox-checked.svg'

type Props = {
    filterItem: FilterItemTransport
    filterType: FilterType
    isMultiSelect?: boolean
    shouldCommit?: boolean
}

const CheckboxFilterItem: FC<Props> = ({ filterItem, filterType, isMultiSelect, shouldCommit = false }) => {
    const [isChecked, setIsChecked] = useState(filterItem.checked)
    const dispatch = useDispatch<Dispatch>()
    const error = useSelector(getFilterError)
    const regionNodeId = useSelector(getRegionNodeId)
    const user = useRequestUserConfigContext()

    const handleClick = useCallback(
        event => {
            preventEvent(event)
            filterGATracking({
                type: filterType,
                name: filterItem.title,
                value: filterItem.value,
                isChecked: !isChecked,
                regionNodeId,
            })
            setIsChecked(!isChecked)
            const filterItemUrl = new URL(filterItem.absoluteLink)
            dispatch(filterClick(encodeToBase64(filterItemUrl.pathname + filterItemUrl.search), shouldCommit, user))
        },
        [filterItem, filterType, isChecked, dispatch, regionNodeId, user, shouldCommit],
    )

    useEffect(() => {
        setIsChecked(filterItem.checked)
    }, [error, filterItem.checked])

    return (
        <Container isMultiSelect={isMultiSelect} $disabled={filterItem.count < 1}>
            <Text>{filterItem.title}</Text>
            <Label onClick={handleClick} checked={isChecked} isMultiSelect={isMultiSelect}>
                {isChecked && <Icon as={CheckboxCheckedIcon as AnyStyledComponent} alt="checkbox checked" />}
                <Input type="checkbox" name={filterType} defaultChecked={isChecked} />
            </Label>
        </Container>
    )
}

export default memo(CheckboxFilterItem)
